/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { mergeAttributes } from "@tiptap/core";
import { Node } from "@tiptap/core";
import { nodeInputRule } from "@tiptap/core";

export const inputRegex = /(?:^|\s)(!\[(.+|:?)]\((\S+)(?:(?:\s+)["'](\S+)["'])?\))$/;

const SimpliCityImage = Node.create({
    name: "image",
    
    addOptions () {
        return {
            inline: false,
            allowBase64: false,
            HTMLAttributes: {},
        };
    },
    
    inline () {
        return this.options.inline;
    },
    
    group () {
        return this.options.inline ? "inline" : "block";
    },
    
    draggable: true,
    
    addAttributes () {
        return {
            guid: {
                default: null,
            },
            src: {
                default: null,
            },
            url: {
                default: null,
            },
            alt: {
                default: null,
            },
            title: {
                default: null,
            },
            caption: {
                default: undefined,
            },
            width: {
                default: null,
            },
            height: {
                default: null,
            },
            style: {
                default: undefined,
            },
            settings: {
                default: null,
            },
            class: {
                default: "simplicity-rich-text-image",
            },
        };
    },
    
    parseHTML () {
        return [
            {
                tag: this.options.allowBase64
                    ? "img[src]"
                    : "img[src]:not([src^=\"data:\"])",
            },
        ];
    },
    
    renderHTML ({ HTMLAttributes }) {
        const settings = HTMLAttributes?.settings;
        const url = HTMLAttributes?.url;
        const { format, options } = settings || {};
        const caption = HTMLAttributes?.caption;
        const { dimension, method, position, useCaption } = options || {};  // useCaption
        const shouldCaption = !!caption && useCaption;
        if (format === "image.format.cropped-focus") {
            HTMLAttributes.height = "400px";
            HTMLAttributes.style = `height: 400px; background-image:url(${url}); background-position: ${position}; background-repeat: no-repeat; background-size: cover;`;
            HTMLAttributes.class = "simplicity-rich-text-image cover";
            HTMLAttributes.settings = "";
            if (shouldCaption) {
                return [
                    "figure",
                    { class: "simplicity-rich-text-figure" },
                    ["img", mergeAttributes(this.options.HTMLAttributes, HTMLAttributes)],
                    ["figcaption", {}, caption]
                ];
            }
            return ["img", mergeAttributes(this.options.HTMLAttributes, HTMLAttributes)];
            // return ['div', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes)]
        } else if (format === "\"image.format.scaled-image") {
            HTMLAttributes.class = "simplicity-rich-text-image";
            if (method === "100Aspect") {
                HTMLAttributes.height = `${dimension}px`;
                HTMLAttributes.class = `simplicity-rich-text-image ${method}`;
            } else if (method === "HeightPriority") {
                HTMLAttributes.height = `${dimension}px`;
                HTMLAttributes.class = `simplicity-rich-text-image ${method}`;
            } else if (method === "WidthPriority") {
                HTMLAttributes.width = `${dimension}px`;
                HTMLAttributes.class = `simplicity-rich-text-image ${method}`;
            }
            HTMLAttributes.settings = "";
            if (shouldCaption) {
                return [
                    "figure",
                    { class: "simplicity-rich-text-figure" },
                    ["img", mergeAttributes(this.options.HTMLAttributes, HTMLAttributes)],
                    ["figcaption", {}, caption]
                ];
            }
            return ["img", mergeAttributes(this.options.HTMLAttributes, HTMLAttributes)];
        } else {
            return ["img", mergeAttributes(this.options.HTMLAttributes, HTMLAttributes)];
        }
    },
    
    addCommands () {
        return {
            setImage: (options) => ({ commands }) => {
                return commands.insertContent({
                    type: this.name,
                    attrs: options,
                });
            },
        //     removeImage: (options) => ({ commands }) => {
        //         return commands.toggleNode('image', 'paragraph')
        //     },
        };
    },
    
    addInputRules () {
        return [
            nodeInputRule({
                find: inputRegex,
                type: this.type,
                getAttributes: (match) => {
                    const [,, alt, src, title] = match;
                    return { src, alt, title };
                },
            }),
        ];
    },
});

export { SimpliCityImage, SimpliCityImage as default };
